import RemoteAccessInProgressModal from './remote-access-in-progress-modal.connect'

export default RemoteAccessInProgressModal
